import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from "@angular/core";

@Component({
	selector: "ic-event-line",
	templateUrl: "./event-line.component.html",
	styleUrls: ["./event-line.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EventLineComponent {
	@Input() events: unknown[] = [];

	@ContentChild("eventTmpl", { static: false }) eventTemplate: TemplateRef<any>;
	@ContentChild("afterTmpl", { static: false }) afterTemplate: TemplateRef<any>;
}
